import { useMemo } from 'react';

import { useUserPermissionsByPgIdMap } from './useEntitiesMap';

export default (userPGID) => {
  const { data: userPermissionsMapByPGID, loading } =
    useUserPermissionsByPgIdMap();

  const data = useMemo(() => {
    return (!loading && userPermissionsMapByPGID[userPGID]) || null;
  }, [userPGID, userPermissionsMapByPGID, loading]);

  return { data: loading ? null : data, loading };
};
